/*
 * Trivzo motion controller.
 *
 * Two jobs, both driven by IntersectionObserver so nothing runs off-screen:
 *   1. `.tz-reveal`  — fade + 14px lift, once, staggered by --tz-order.
 *   2. `.tz-scan`    — arms the ATS scan animation the first time it is seen.
 *
 * No dependencies. Bails out entirely when the visitor prefers reduced motion,
 * leaving content in its final visible state.
 */
(function () {
  'use strict';

  // Mark the document as script-capable before first paint so the CSS hidden
  // start state applies only when this file is running to undo it.
  document.documentElement.classList.add('tz-js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function revealAll() {
    document.querySelectorAll('.tz-reveal').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  function init() {
    // Reduced motion, or no observer support: show everything immediately.
    if (reduce.matches || !('IntersectionObserver' in window)) {
      revealAll();
      document.querySelectorAll('.tz-scan').forEach(function (el) {
        el.classList.add('is-live');
      });
      return;
    }

    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    document.querySelectorAll('.tz-reveal').forEach(function (el) {
      revealObserver.observe(el);
    });

    // The scan needs more of itself on screen before it earns the attention.
    var scanObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-live');
          scanObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    document.querySelectorAll('.tz-scan').forEach(function (el) {
      scanObserver.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
